import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  Typography,
  Box,
  IconButton,
  CircularProgress,
  Tooltip,
  Tabs,
  Tab,
  Stack,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from "@mui/material";
import Iconify from "src/components/Iconify";
import { capitalCase } from "change-case";
import { string_with_limited_length } from "src/utils/common";
import { useSnackbar } from "notistack";
import { LoadingButton } from "@mui/lab";

export default function SplitTextDialog({
  open,
  onClose,
  textToSplit,
  setTextToSplit,
  task,
  targetChecklist,
  updateChecklistItems,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [split, setSplit] = useState("yes");

  const handleConfirmSplit = async () => {
    let text_into_items;

    if (split === "yes") {
      text_into_items = textToSplit.map((item) => ({
        name: item,
        status: false,
      }));
    } else {
      text_into_items = [
        {
          name: textToSplit.join("\n"),
          status: false,
        },
      ];
    }

    setLoading(true);

    const req_obj = {
      task_id: task?._id,
      list_id: targetChecklist._id,
      list_item_array: [
        ...targetChecklist.items.map((item) => ({
          name: item.name,
          status: item.status,
          createdAt: item.createdAt,
          // updatedAt: item.updatedAt,
        })),
        ...text_into_items,
      ],
    };
    await updateChecklistItems(req_obj);
    handleClose();
  };

  const handleClose = () => {
    onClose();
    setSplit("yes");
    setTextToSplit([]);
    setLoading(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{ "& .MuiDialog-paper": { width: "100% " } }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          Split Items
          <IconButton size="small" onClick={handleClose}>
            <Iconify
              icon="ion-close"
              sx={{
                height: "24px",
                width: "24px",
              }}
            />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ padding: "0px 24px 10px 24px" }}>
        <Box mb={2}>
          <Typography>
            Your input has multiple lines. Do you want to create separate
            checklist items for each line?
          </Typography>
        </Box>

        <RadioGroup
          row
          value={split}
          onChange={(e) => setSplit(e.target.value)}
        >
          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
          <FormControlLabel value="no" control={<Radio />} label="No" />
        </RadioGroup>
      </DialogContent>

      <DialogActions>
        <Button disabled={loading} onClick={handleClose}>
          cancel
        </Button>
        <LoadingButton
          loading={loading}
          onClick={handleConfirmSplit}
          variant="contained"
        >
          continue
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
